exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-container[data-v-bcc1e540]{width:55%}@media screen and (max-width:767px){.icon-container[data-v-bcc1e540]{width:100%}}.divider[data-v-bcc1e540]{width:100%}.divider hr[data-v-bcc1e540]{margin-top:-20px;border-width:2px 0 0}.divider hr.border-dash[data-v-bcc1e540]{border-style:dashed}.divider hr.border-solid[data-v-bcc1e540]{border-style:solid}", ""]);

// exports
